{
  "upload": {
    "title": "Your Trademark",
    "subtitle": "Upload your trademark image or enter a word mark",
    "selectType": "Which option best describes your trademark?",
    "logoTrademark": "Logo trademark",
    "logoDescription": "Brand logo including text",
    "figurativeTrademark": "Figurative trademark",
    "figurativeDescription": "Graphical elements of the brand without text",
    "wordTrademark": "Word trademark",
    "wordDescription": "Brand name or slogan",
    "uploadYour": "Upload your {{type}} trademark",
    "dragDrop": "Drag and drop your image here, or",
    "browseFiles": "browse files",
    "supportedFormats": "Supported formats: PNG, JPG, GIF",
    "enterWordMark": "Enter your word trademark",
    "wordPlaceholder": "Enter your trademark text",
    "uploadWordMark": "Upload Word Mark",
    "removeImage": "Remove Image",
    "uploading": "Uploading trademark...",
    "uploadSuccess": "Trademark uploaded successfully!",
    "imageSuccess": "Image trademark uploaded successfully",
    "uploadDifferent": "Upload Different Trademark",
    "selectImage": "Select an image to upload automatically",
    "uploadError": "Failed to upload trademark. Please try again."
  },
  "analysis": {
    "title": "AI-Powered Analysis",
    "subtitle": "Our AI will analyse your trademark for distinctiveness, potential conflicts, and registration strategy",
    "readyTitle": "Ready for AI-Powered Trademark Analysis",
    "readySubtitle": "Our AI will analyse your trademark for distinctiveness, potential conflicts, and registration strategy",
    "yourTrademark": "Your Trademark",
    "trademarkRequired": "Trademark Required",
    "businessProfile": "Business Profile",
    "businessRequired": "Business Profile Required",
    "trademarkName": "Trademark Name",
    "trademarkNameDesc": "This is the name or text that will be protected under your trademark registration",
    "trademarkType": "Trademark Type",
    "logoTypeDesc": "A visual design or logo that represents your brand",
    "wordTypeDesc": "A word or phrase that identifies your goods or services",
    "detailedDescription": "Detailed Description",
    "trademarkDescription": "Trademark Description",
    "viewDescription": "View detailed trademark description",
    "descriptionHelp": "This description helps our AI understand the visual and conceptual elements of your trademark",
    "descRequired": "Description Required",
    "descRequiredMsg": "Please add a detailed description of your trademark to proceed with analysis",
    "descRequiredHelp": "A good description includes colors, design elements, fonts, and overall appearance",
    "noTrademark": "No Trademark Selected",
    "noTrademarkMsg": "Please complete the trademark upload step first",
    "noTrademarkHelp": "You need to upload your trademark before we can analyse it",
    "readyToAnalyse": "Ready to Analyse",
    "analyseButton": "Analyse My Trademark",
    "analysing": "Analysing your trademark...",
    "analysisComplete": "Analysis Complete",
    "viewReport": "View Full Report",
    "overallScore": "Overall Score",
    "distinctiveness": "Distinctiveness",
    "conflictRisk": "Conflict Risk",
    "registrability": "Registrability",
    "recommendations": "Recommendations",
    "potentialConflicts": "Potential Conflicts",
    "noConflicts": "No significant conflicts found",
    "needsUpload": "You need to upload your trademark before we can analyse it",
    "classRecommendations": "Class Recommendations",
    "suggestedClasses": "Suggested Nice Classes"
  },
  "business": {
    "title": "Business Information",
    "complete": "Business Information Complete",
    "completeDescription": "Your business information has been successfully saved and will be used to provide accurate trademark recommendations.",
    "subtitle": "Tell us about your business so Marko can provide personalised recommendations",
    "ownerType": "Trademark Owner Type",
    "individual": "Individual",
    "company": "Company",
    "partnership": "Partnership",
    "businessName": "Business Name",
    "tradingAs": "Trading As",
    "registrationNumber": "Registration Number",
    "industry": "Industry",
    "selectIndustry": "Select your industry",
    "goodsServices": "Goods & Services",
    "describeGoodsServices": "Describe the goods or services your trademark will cover",
    "markoAnalyse": "Marko will analyse your information for completeness as you type.",
    "analysed": "I've analysed your trademark"
  },
  "classes": {
    "title": "Nice Classification",
    "subtitle": "Select the classes that best describe your goods and services",
    "selectedClasses": "Selected Classes",
    "noClassesSelected": "No classes selected",
    "addClass": "Add Class",
    "removeClass": "Remove Class",
    "searchClasses": "Search classes...",
    "classNumber": "Class {{number}}",
    "viewDetails": "View class details"
  }
}
